import { Link } from "react-router-dom";
import type { TableRowView, TagBox } from "../../lib/api";
import { documentViewPath } from "../../pages/documentViewFlow";
import { displayName } from "../../lib/words";
import { TableScroll } from "../TableScroll";

/** The cited value an asset view opens on its page. */
export interface RowCitation { path: string; page: number; box: TagBox | null; label: string }

const SHOWN: [string, keyof TableRowView][] = [
  ["Make", "make"], ["Model", "model"], ["Serial", "serial"], ["Service", "service"], ["Range", "calibration_range"],
];

/**
 * The rows read from the package's tables for one tag, on its asset view. Each value with a box
 * opens its page with the box drawn; the document link opens the table page in the document view.
 */
export function TableRowsForTag({ rows, onCite }: { rows: TableRowView[]; onCite: (c: RowCitation) => void }) {
  if (rows.length === 0) return null;
  return (
    <section className="card" style={{ marginTop: 20, padding: 16 }} aria-label="Rows read from tables">
      <h3 style={{ fontSize: 16, marginBottom: 4 }}>Rows read from tables</h3>
      <p className="muted" style={{ fontSize: 13, marginBottom: 10 }}>
        Candidates for the register, read by Claude from a list page and checked against it. A person accepts them.
      </p>
      <TableScroll label="Rows read from tables, scrollable">
        <table>
          <thead>
            <tr><th scope="col">Document</th>{SHOWN.map(([h]) => <th key={h} scope="col">{h}</th>)}</tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id}>
                <td>
                  <Link to={`${documentViewPath(r.package, r.document_id)}?page=${r.page}`}>{displayName(r.file_name)}, page {r.page}</Link>
                  {r.row_class && <div className="muted" style={{ fontSize: 12 }}>{r.row_class}</div>}
                  {r.status !== "verified" && <span className="pill fail">tag not found on the page</span>}
                </td>
                {SHOWN.map(([h, key]) => {
                  const value = r[key] as string | null;
                  if (!value) return <td key={h} className="muted">-</td>;
                  // The column that feeds this field, never another column holding the same text.
                  const cell = r.cells.find((c) => c.field === key);
                  return (
                    <td key={h}>
                      {cell?.box ? (
                        <button type="button" className="ghost docview-cell" aria-label={`Show ${h} ${value} on its page`}
                                onClick={() => onCite({ path: r.path, page: r.page, box: cell.box, label: `${h}: ${value}` })}>
                          {value}
                        </button>
                      ) : value}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </TableScroll>
    </section>
  );
}
